module.exports = __webpack_public_path__ + "img/multi-6.00ce3b90.svg";